import Component from './Intro';
import I18nService from '../../../services/I18nService';
// import DebugService from '../../../services/DebugService';

import { connect } from 'react-redux';

// on map le state de redux sur les props du composant
const mapStateToProps = (state) => {
  // const {globalKey,flow} = state.app;

  // i18n service
  const myI18nService = I18nService.getInstance();
  const hasIntro = myI18nService.exists('label.welcomeMessage');

  // if (DebugService.getInstance().enabled) console.log('Intro - ',{hasIntro,welcome: myI18nService.t('label.welcomeMessage')});

  return {
    hasIntro,
    label: hasIntro ? myI18nService.t('label.welcomeMessage') : undefined,
  };
};

export default connect(mapStateToProps, undefined)(Component);
